export enum SectionTitle {
  DISCHARGE_SUMMARY = 'Discharge Summary',
  REASON_FOR_ADMISSION = 'Reason for Admission',
  TREATING_TEAM_AND_CONTACT_DETAILS = 'Treating Team and Contact Details',
  CLINICAL_SUMMARY = 'Clinical Summary',
  MEDICATIONS = 'Medications',
  FOLLOW_UP_AND_REFERRALS = 'Follow-Up and Referrals',
  PATIENT_EDUCATION_AND_INSTRUCTIONS = 'Patient Education and Instructions',
  SUPPORT_SERVICES_AND_EQUIPMENT = 'Support Services and Equipment',
  CONSENT_AND_COMMUNICATION = 'Consent and Communication',
  CLINICAL_HANDOVER = 'Clinical Handover',
  CLINICIAN_SIGNATURE = 'Clinician Signature'
}

export enum FormField {
  // Dates
  ADMISSION_DATE = 'admissionDate',
  DISCHARGE_DATE = 'dischargeDate',

  // Reason for Admission
  PRESENTING_PROBLEM = 'presentingProblem',
  PRINCIPAL_DIAGNOSIS = 'principalDiagnosis',
  ADDITIONAL_DIAGNOSIS = 'additionalDiagnosis',
  SUMMARY_OF_HOSPITAL_STAY = 'summaryOfHospitalStay',

  // Treating Team
  ATTENDING_CLINICIANS = 'attendingClinicians',
  WARD_UNIT = 'wardUnit',

  // Clinical Summary
  KEY_INVESTIGATIONS_AND_RESULTS = 'keyInvestigationsAndResults',
  PROCEDURES_PERFORMED = 'proceduresPerformed',
  RESPONSE_TO_TREATMENT = 'responseToTreatment',
  OUTSTANDING_ISSUES = 'outstandingIssues',

  // Medications
  DISCHARGE_MEDICATIONS = 'dischargeMedications',
  CHANGES_FROM_ADMISSION_MEDICATIONS = 'changesFromAdmissionMedications',
  REASONS_FOR_CHANGES = 'reasonsForChanges',
  ALLERGIES_AND_ADVERSE_DRUG_REACTIONS = 'allergiesAndAdverseDrugReactions',

  // Follow-up & Referrals
  APPOINTMENTS = 'appointments',
  REFERRALS_TO = 'referralsTo', // checkbox group
  REFERRALS_TO_OTHER = 'referralsToOther', // conditional textbox
  NOTES = 'notes',

  // Patient Education
  DISCHARGE_INSTRUCTIONS = 'dischargeInstructions',
  WARNING_SIGNS_TO_WATCH_FOR = 'warningSignsToWatchFor',
  CONTACT_INFORMATION_FOR_URGENT_CONCERNS = 'contactInformationForUrgentConcerns',

  // Support Services
  HOME_CARE_SERVICES_ARRANGED = 'homeCareServicesArranged',
  EQUIPMENT_PROVIDED = 'equipmentProvided',
  TRANSPORT_ARRANGEMENTS = 'transportArrangements',

  // Consent & Communication
  PATIENT_CARER_INVOLVEMENT_IN_DISCHARGE_PLANNING = 'patientCarerInvolvementInDischargePlanning',
  INTERPRETER_SERVICES_USED = 'interpreterServicesUsed',
  CONSENT_FOR_INFORMATION_SHARING = 'consentForInformationSharing',

  // Clinical Handover
  HANDOVER_TO_RECEIVING_HEALTHCARE_PROVIDER = 'handoverToReceivingHealthcareProvider',

  // Signature
  CLINICIAN_SIGNATURE_NAME = 'clinicianSignatureName',
  CLINICIAN_SIGNATURE_POSITION = 'clinicianSignaturePosition',
  CLINICIAN_SIGNATURE_DATE = 'clinicianSignatureDate'
}

export enum FormFieldLabel {
  // Dates
  ADMISSION_DATE = 'Admission Date',
  DISCHARGE_DATE = 'Discharge Date',

  // Reason for Admission
  PRESENTING_PROBLEM = 'Presenting Problem',
  PRINCIPAL_DIAGNOSIS = 'Principal Diagnosis',
  ADDITIONAL_DIAGNOSIS = 'Additional Diagnosis',
  SUMMARY_OF_HOSPITAL_STAY = 'Summary of Hospital Stay',

  // Treating Team
  ATTENDING_CLINICIANS = 'Attending Clinician(s)',
  WARD_UNIT = 'Ward/Unit',

  // Clinical Summary
  KEY_INVESTIGATIONS_AND_RESULTS = 'Key Investigations and Results',
  PROCEDURES_PERFORMED = 'Procedures Performed',
  RESPONSE_TO_TREATMENT = 'Response to Treatment',
  OUTSTANDING_ISSUES = 'Outstanding Issues',

  // Medications
  DISCHARGE_MEDICATIONS = 'Discharge Medications',
  CHANGES_FROM_ADMISSION_MEDICATIONS = 'Changes from Admission Medications',
  REASONS_FOR_CHANGES = 'Reasons for Changes',
  ALLERGIES_AND_ADVERSE_DRUG_REACTIONS = 'Allergies and Adverse Drug Reactions',

  // Follow-up & Referrals
  APPOINTMENTS = 'Appointments (Date, Time, Location)',
  REFERRALS_TO = 'Referrals to:',
  REFERRALS_TO_OTHER = 'Other',

  // Patient Education
  DISCHARGE_INSTRUCTIONS = 'Discharge Instructions (e.g., Wound Care, Mobility)',
  WARNING_SIGNS_TO_WATCH_FOR = 'Warning Signs to Watch For',
  CONTACT_INFORMATION_FOR_URGENT_CONCERNS = 'Contact Information for Urgent Concerns',

  // Support Services
  HOME_CARE_SERVICES_ARRANGED = 'Home Care Services Arranged',
  EQUIPMENT_PROVIDED = 'Equipment Provided (e.g., Mobility Aids, Oxygen)',
  TRANSPORT_ARRANGEMENTS = 'Transport Arrangements',

  // Consent & Communication
  PATIENT_CARER_INVOLVEMENT_IN_DISCHARGE_PLANNING = 'Patient and/or Carer Involvement in Discharge Planning',
  INTERPRETER_SERVICES_USED = 'Interpreter Services Used (if applicable)',
  CONSENT_FOR_INFORMATION_SHARING = 'Consent for Information Sharing',

  // Clinical Handover
  HANDOVER_TO_RECEIVING_HEALTHCARE_PROVIDER = 'Handover to Receiving Healthcare Provider',

  // Signature
  CLINICIAN_SIGNATURE_NAME = 'Name',
  CLINICIAN_SIGNATURE_POSITION = 'Position',
  CLINICIAN_SIGNATURE_DATE = 'Date'
}
